import {
  axiosDeleteRequest,
  axiosGetRequest,
  axiosPostRequest,
  axiosPutRequest,
  getHealthPictureRoute,
  getReferenceRoute,
} from '../../api';
import { CreateConsultationDto, UpdateConsultationDto } from './dtos';
import { Consultation, ConsultationType } from './models';

const getConsultationRoute = () => `${getHealthPictureRoute()}/consultations`;
const getConsultationTypeRoute = () => `${getReferenceRoute()}/consultations`;

export const fetchConsultationsCall = (healthjourneyId: string) => {
  return axiosGetRequest<Consultation[]>(
    `${getConsultationRoute()}/${healthjourneyId}`
  );
};

export const createConsultationCall = (
  newConsultation: CreateConsultationDto
) => {
  return axiosPostRequest<CreateConsultationDto, Consultation>(
    `${getConsultationRoute()}`,
    newConsultation
  );
};

export const updateConsultationCall = (consultation: UpdateConsultationDto) => {
  return axiosPutRequest<UpdateConsultationDto, Consultation>(
    `${getConsultationRoute()}`,
    consultation
  );
};

export const deleteConsultationCall = (consultationId: string) => {
  return axiosDeleteRequest<string, void>(
    `${getConsultationRoute()}/${consultationId}`
  );
};

export const fetchConsultationTypesCall = () => {
  return axiosGetRequest<ConsultationType[]>(`${getConsultationTypeRoute()}`);
};
